import { render } from "./CommunityDelete.vue?vue&type=template&id=283f34a0"
import script from "./CommunityDelete.vue?vue&type=script&lang=js"
export * from "./CommunityDelete.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__